import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Fragment, useEffect, useState } from "react";

export default function Modal({
  title,
  description,
  children,
  triggerClose = false,
  onCancel = () => {},
  onSubmit = () => {},
  onClose = () => {},
  hasCancel = true,
  maxWidth = "max-w-[25rem]",
  width = "w-full",
  hasClose = false,
  hasSubmit = true,
  submitText = "확인",
  bgSubmit = "bg-primary-blue",
  widthButton = "w-[5rem]",
  widthSubmitButton = "w-[5rem]",
  closable = true,
  rightTittle,
  childrenWidth,
  padding = "p-4",
  paddingTitle,
  cancelText = "취소",
  marginButton = "mx-2",
  isOpenFromOutside = null,
  setIsOpenFromOutside,
  lineHeight = "",
  height,
}) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (triggerClose === true) {
      setIsOpen(false);
      if (isOpenFromOutside !== null) {
        setIsOpenFromOutside(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerClose]);

  function handleCancel() {
    setIsOpen(false);
    if (isOpenFromOutside !== null) {
      setIsOpenFromOutside(false);
    }
    onCancel();
  }

  function handleSubmit() {
    setIsOpen(false);
    if (isOpenFromOutside !== null) {
      setIsOpenFromOutside(false);
    }
    onSubmit();
  }

  function closeModal() {
    setIsOpen(false);
    if (isOpenFromOutside !== null) {
      setIsOpenFromOutside(false);
    }
    onClose();
  }

  function openModal() {
    setIsOpen(true);
    if (isOpenFromOutside !== null) {
      setIsOpenFromOutside(true);
    }
  }

  return (
    <>
      <div className={childrenWidth} onClick={openModal}>
        {children}
      </div>
      <Transition
        appear
        show={isOpen === true || isOpenFromOutside === true}
        as={Fragment}
      >
        <Dialog
          as="div"
          className="relative z-[99]"
          onClose={closable === true ? closeModal : () => {}}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className={`${width} ${maxWidth} ${height} p-4 transform overflow-hidden bg-white text-left align-middle shadow-xl transition-all`}
                >
                  {title && (
                    <>
                      <div
                        className={`flex ${paddingTitle} justify-between items-center`}
                      >
                        <Dialog.Title
                          as="h3"
                          className="text-[14px] font-bold leading-6 text-black"
                        >
                          {title}
                        </Dialog.Title>
                        {hasClose && (
                          <div
                            className="cursor-pointer font-bold text-[14px]"
                            onClick={handleCancel}
                          >
                            <XMarkIcon className="w-5" />
                          </div>
                        )}
                        {rightTittle && rightTittle}
                      </div>
                      <hr className="my-4" />
                    </>
                  )}
                  <div className="mt-2">
                    <div className={`text-[12px] text-black`}>
                      {description}
                    </div>
                  </div>
                  {hasSubmit || hasCancel ? (
                    <div
                      className={`flex ${marginButton} justify-end gap-2 mb-2 mt-4`}
                    >
                      {hasCancel ? (
                        <button
                          type="button"
                          className={`inline-flex justify-center border border-primary-blue bg-white px-2 text-[12px] font-medium text-primary-blue py-1 ${widthButton} rounded-[4px]`}
                          onClick={handleCancel}
                        >
                          {cancelText}
                        </button>
                      ) : null}
                      {hasSubmit ? (
                        <button
                          type="button"
                          className={`inline-flex justify-center border border-transparent ${bgSubmit} px-2 text-[12px] font-medium text-white py-1 ${widthSubmitButton} rounded-[4px]`}
                          onClick={handleSubmit}
                        >
                          {submitText}
                        </button>
                      ) : null}
                    </div>
                  ) : null}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
